export default {
  LIST_STATUS_NO_DATA: -1,
  LIST_STATUS_READY: 0,
  LIST_STATUS_LOADING: 1,

  LIST_METADATA_STATUS_NO_DATA: -1,
  LIST_METADATA_STATUS_READY: 0,
  LIST_METADATA_STATUS_LOADING: 1
};
